import { render, staticRenderFns } from "./NewFormBox.vue?vue&type=template&id=527bc7fe&scoped=true"
import script from "./NewFormBox.vue?vue&type=script&lang=js"
export * from "./NewFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NewFormBox.vue?vue&type=style&index=2&id=527bc7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bc7fe",
  null
  
)

export default component.exports